module.exports = __webpack_public_path__ + "media/supremevid.a0eea423.mp4";